import discountService from '../services/discount'
import {
  SET_DISCOUNTS,
  SET_DISCOUNTS_LOADING,
  SET_DISCOUNTS_ERROR,
  REMOVE_DISCOUNT
} from '../mutation-types'

// State
export const state = {
  discounts: [],
  loading: false,
  error: null
}

// Getters
export const getters = {
  discounts: state => state.discounts,
  activeDiscounts: state => state.discounts.filter(d => d.is_active),
  discountItems: state => state.discounts.map(d => ({ value: d.value, label: d.label })),
  discountsLoading: state => state.loading,
  discountsError: state => state.error
}

// Mutations
export const mutations = {
  [SET_DISCOUNTS](state, discounts) {
    state.discounts = discounts
  },

  [SET_DISCOUNTS_LOADING](state, loading) {
    state.loading = loading
  },

  [SET_DISCOUNTS_ERROR](state, error) {
    state.error = error
  },

  [REMOVE_DISCOUNT](state, id) {
    state.discounts = state.discounts.filter(d => d.id !== id)
  }
}

// Actions
export const actions = {
  async fetchDiscounts({ commit }, { admin = false } = {}) {
    commit(SET_DISCOUNTS_LOADING, true)
    commit(SET_DISCOUNTS_ERROR, null)
    try {
      const { data } = admin
        ? await discountService.getAllAdmin()
        : await discountService.getAll()
      commit(SET_DISCOUNTS, data.results || [])
      return data
    } catch (error) {
      commit(SET_DISCOUNTS_ERROR, error.response?.data?.message || 'Failed to fetch discounts')
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  },

  async fetchActiveDiscounts({ commit }) {
    commit(SET_DISCOUNTS_LOADING, true)
    commit(SET_DISCOUNTS_ERROR, null)
    try {
      const { data } = await discountService.getAll()
      commit(SET_DISCOUNTS, data.results || [])
      return data
    } catch (error) {
      commit(SET_DISCOUNTS_ERROR, error.response?.data?.message || 'Failed to fetch discounts')
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  },

  async createDiscount({ commit, dispatch }, payload) {
    commit(SET_DISCOUNTS_LOADING, true)
    try {
      const { data } = await discountService.create(payload)
      await dispatch('fetchDiscounts', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  },

  async updateDiscount({ commit, dispatch }, { id, payload }) {
    commit(SET_DISCOUNTS_LOADING, true)
    try {
      const { data } = await discountService.update(id, payload)
      await dispatch('fetchDiscounts', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  },

  async deleteDiscount({ commit, dispatch }, id) {
    commit(SET_DISCOUNTS_LOADING, true)
    try {
      const { data } = await discountService.delete(id)
      commit(REMOVE_DISCOUNT, id)
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  },

  async updateDiscountOrder({ commit, dispatch }, ids) {
    commit(SET_DISCOUNTS_LOADING, true)
    try {
      const { data } = await discountService.updateOrder(ids)
      await dispatch('fetchDiscounts', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_DISCOUNTS_LOADING, false)
    }
  }
}
